<template>
  <svg
    width="24px"
    height="20px"
    viewBox="0 0 24 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="00-Framework" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Framework" transform="translate(-1291.000000, -318.000000)" fill="currentColor">
        <g id="typo" transform="translate(347.000000, 303.000000)">
          <g id="Group-3" transform="translate(-0.000000, -0.000000)">
            <g id="Presets" transform="translate(944.000000, 14.000000)">
              <g id="größe">
                <g id="Actions-/-Navigation-/-home-/-24">
                  <path
                    d="M12.4575,1.6575 C12.1849164,1.44210181 11.8000836,1.44210181 11.5275,1.6575 L0.75,10.065 L1.68,11.25 L3,10.215 L3,19.5 C3,20.3284271 3.67157288,21 4.5,21 L19.5,21 C20.3284271,21 21,20.3284271 21,19.5 L21,10.2225 L22.32,11.25 L23.25,10.0725 L12.4575,1.6575 Z M13.5,19.5 L10.5,19.5 L10.5,13.5 L13.5,13.5 L13.5,19.5 Z M15,19.5 L15,13.5 C15,12.6715729 14.3284271,12 13.5,12 L10.5,12 C9.67157288,12 9,12.6715729 9,13.5 L9,19.5 L4.5,19.5 L4.5,9.045 L12,3.2025 L19.5,9.0525 L19.5,19.5 L15,19.5 Z"
                    id="Fill"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'House'
};
</script>
